import React, { useState, useEffect } from 'react';
import { Grid, Typography, Card, CardContent, CardMedia, CardActionArea } from '@mui/material';
import { styleDetalleSubModulo } from '../Tool/Style';
import { ContabilizarAccesoModuloUsuario } from '../../Actions/Usuarios/UsuarioAction';
import { obtenerDatosAppExternas } from '../../Actions/ClassStore/AppExternasAction';
import { useStateValue } from '../../Contexto/store';
import { GnlUrlBaseServicios, GnlUrlVisorReportes, GnlUrlCarpetaReportesMigrador, LlavesInformesConfig } from '../../Configuracion/Llaves/RepositorioConfig';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            boxShadow: "1px 2px #d1d3e1 !important"
        }
    }));

const DetalleSubModuloExterno = ({ Titulo, Submodulo, UrlModulo, Icono, Detalles, IdModulo, Referencia, ModuloExterno }) => {
    const classes = useStyles();

    const [{ sesionUsuario, compania, etiquetasIdioma }, dispatch] = useStateValue();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const utf8ToBase64 = (str) => {
        return window.btoa(encodeURIComponent(str));
    };

    const contabilizar = async () => {
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Cargando });
        await ContabilizarAccesoModuloUsuario(sesionUsuario.usuario.userId, sesionUsuario.usuario.companyId, IdModulo);       
        localStorage.setItem("Modulo" + Referencia, IdModulo);
        let stringDatos = "";

        if (ModuloExterno === false) {            
            window.location.href = UrlModulo;
            //dispatch({ type: "CLOSE_LOAD_COMP" });
        }
        else {
            const etiIdioma = window.localStorage.getItem("etiqueta_idioma");
            const peticionDatos = {
                UserEmail: sesionUsuario.usuario.email,
                CustomerId: sesionUsuario.usuario.customerId,
                FullName: sesionUsuario.usuario.nombreCompleto,
                BaseUrl: GnlUrlBaseServicios,
                CompanyId: sesionUsuario.usuario.companyId,
                CompanyName: compania.ComName,
                UserId: sesionUsuario.usuario.userId,
                Token: window.localStorage.getItem("token_seguridad"),
                LanguageCode: etiIdioma,
                ProfilePicture: ""//sesionUsuario.usuario.imagenPerfil
            };

            const responseDatos = await obtenerDatosAppExternas(peticionDatos);
            
            if (responseDatos.status === 200) //si la respuesta fue existosa
            {
                if (UrlModulo.includes("?"))
                    stringDatos = "&";
                else
                    stringDatos = "?";

                stringDatos += "q=" + responseDatos.data;                

                if (Referencia.toLowerCase() === 'automigrador' || Referencia.toLowerCase() === 'contratos') {

                    const objeto = {
                        url: LlavesInformesConfig.SSSRConfig.RootFolder,
                        carpeta: Referencia.toLowerCase() === 'automigrador' ? GnlUrlCarpetaReportesMigrador : 'Contratos',
                        urlVisor: GnlUrlVisorReportes
                    };

                    stringDatos += "&rpt=" + utf8ToBase64(JSON.stringify(objeto));       
                }
            }            

            const urlRedireccionar = UrlModulo + stringDatos;
            window.open(urlRedireccionar, "_blank");
            dispatch({ type: "CLOSE_LOAD_COMP" });            
        }
    };

    return (
        //component='a' href={UrlModulo}
        <Grid item xs={!Detalles ? 12 : 12} sm={!Detalles ? 6 : 4} md={!Detalles ? 3 : 3} >
            <Card style={styleDetalleSubModulo.Card} className={classes.root} >
                <CardActionArea component='button' onClick={contabilizar} style={Detalles ? styleDetalleSubModulo.CardActionArea : styleDetalleSubModulo.CardActionAreaDetallesFull}>
                    <CardMedia style={{ ...(Detalles ? styleDetalleSubModulo.CardMedia : styleDetalleSubModulo.CardMediaDetallesFull), ...{ objectFit: 'fill' } }}
                        component="img"
                        image={Icono}
                        alt={Titulo}                        
                    />
                    <CardContent style={Detalles ? styleDetalleSubModulo.CardContent : styleDetalleSubModulo.CardContentFull}>
                        {
                            !Detalles ? (
                                <React.Fragment>
                                    <Typography variant='subtitle1'>{Titulo}</Typography>
                                    <Typography variant='subtitle2'>{Submodulo}</Typography>
                                </React.Fragment>
                            )
                                : (<Typography variant='subtitle2' style={{ fontWeight: 400 }}>{Submodulo}</Typography>)
                        }
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );
}

export default DetalleSubModuloExterno;